module.exports = __webpack_public_path__ + "img/tl2_m.adef6eec.png";